import React from "react";

export default function EditorHeader({ step, onBack, onStepChange, isStepEnabled, compact = false }) {
  const title =
    step === 1 ? "Select Variation" : step === 2 ? "Select the goal selector" : "Variations Preview";

  return (
    <>
      <div className={`header-nav ${compact ? "header-nav-compact" : ""}`}>
        <div className={`step-header-group ${compact ? "step-header-group-compact" : ""}`}>
          {compact && <div className="compact-step-title">{title}</div>}
          <div className="step-indicator">
            {[1, 2, 3].map((s) => (
              <React.Fragment key={s}>
                <div
                  className={`step ${step >= s ? "active" : ""}`}
                  onClick={() => {
                    if (!isStepEnabled || isStepEnabled(s)) onStepChange?.(s);
                  }}
                  style={{ cursor: !isStepEnabled || isStepEnabled(s) ? "pointer" : "not-allowed" }}
                >
                  {s}
                </div>
                {s < 3 && <div className="step-line" />}
              </React.Fragment>
            ))}
          </div>
        </div>

        <button className={`header-back-btn ${compact ? "header-back-btn-compact" : ""}`} onClick={onBack}>
          Back
        </button>
      </div>

      <div className={`step-header ${compact ? "step-header-compact" : ""}`}>{title}</div>
    </>
  );
}
